exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3VZe-wsP5VLwHRnPNSVopN:focus{outline:1px solid \"[theme:neutralSecondary, default:#605e5c]\"!important}.H2hvpAQzVlxLeV2GkcRwf{cursor:pointer}", ""]);
// Exports
exports.locals = {
	"persona": "_3VZe-wsP5VLwHRnPNSVopN",
	"personaName": "H2hvpAQzVlxLeV2GkcRwf"
};